export default __webpack_public_path__ + "static/media/NotoSans-SemiBold.54d203ce.ttf";